import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery } from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';

import backgroundImage from '../../assets/images/background.png';

import './styles.css';

export default function Home() {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="home-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="home-content">
        <div>
          <h1>A Secretaria Municipal de Meio Ambiente,</h1>
          <h3>visando desburocatrizar o Licenciamento Ambiental de Empresas de Pequeno Porte e de Baixo Impacto Ambiental, disponibiliza um formulário para emissão online do Requerimento de Licença Ambiental Declaratória - LAD</h3>
        </div>
        <div className="home-content-buttons">
          <button className="btn-regras" onClick={handleClickOpen}>Regras</button>
          <Link to="/licenca">
            <button className="btn-licenca">Preencher Licença</button>
          </Link>
        </div>
      </div>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Regras"}</DialogTitle>
        <DialogContent>
          <div style={{ color: '#555', lineHeight: 2 }}>
            De acordo com o art. 5º da Resolução nº 001 de 30/10/2014 do Conselho Municipal de Desenvolvimento Ambiental Sustentável de Aparecida de Goiânia, é <strong>vedada a emissão da LAD</strong> para:
            <ul>
              <li>Empreendimentos sujeitos ao Estudo de Impacto Ambiental e respectivo Relatório de Impacto Ambiental;</li>
              <li>Empreendimentos embargados pelos órgãos integrantes do SISNAMA ou pelo Poder Judiciário, por representar riscos à saúde pública;</li>
              <li>Empreendimentos que tiveram ou venham a ter licença de instalação negada por incompatibilidade ambiental da área com o tipo de atividade;</li>
              <li>Empreendimentos localizados em área contaminada com produtos que apresentem riscos à saúde humana;</li>
              <li>Empreendimentos com porte superior a 250m².</li>
            </ul>

            E ainda, os empreendimentos deverão <strong>observar as seguintes condições</strong>:
            <ul>
              <li>Não realizar intervenções em Área de Preservação Ambiental e/ou Reserva Legal quando da sua implantação;</li>
              <li>Não realizar supressão de vegetação nativa, nem o corte de árvores isoladas;</li>
              <li>Não realizar operações de tratamento térmico, tratamento superficial, pintura eletrostática, pintura por aspersão fundição, curtimento de couro, lavagem e/ou desinfecção de material plástico para recuperação;</li>
              <li>Não gerar Resíduos Sólidos Classe I - Perigosos, conforme normas técnicas vigentes;</li>
              <li>Não exceder a capacidade de armazenamento de Gás Liquefeito de Petróleo - GLP de 4.000kg;</li>
              <li>Não realizar queima de combustíveis;</li>
              <li>Atender aos critérios de porte.</li>
            </ul>

            <strong>Considerações Importantes:</strong><br />
<br/>
            <strong>Art. 14</strong> - A LAD poderá ser suspensa ou cancelada em casos de descumprimento ou inadequação de quaisquer condicionantes descritas ou normas legais, por omissão ou falsa descrição de informações relevantes para subsidiar a expedição da licença, por superveniência de graves riscos ambientais e por determinação judicial constante de sentença, alvará ou mandado.
            <br/>
            <strong>Art. 16</strong> - A LAD terá prazo máximo de validade correspondente a 02(dois) anos.
            <br/>
            <strong>§ 1º</strong> - A renovação da LAD deverá ser requerida com antecedênica mínima de 120(cento e vinte) dias da expiração de seu prazo de validade, ficando prorrogada até a manifestação definitiva deste órgão.
          </div>
        </DialogContent>
        <DialogActions>
          <Button style={{ border: "2px solid #069c7c", color: '#069c7c', marginTop: 10, marginBottom: 10, marginRight: 10, borderRadius: 5, paddingLeft: 20, paddingRight: 20, paddingTop: 8, paddingBottom: 8}} onClick={handleClose} color="primary" autoFocus>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  )
}
